import axios from "axios";

var FormData = require("form-data");

export default class ApiManager {
  token =
    typeof window !== "undefined" && localStorage.getItem("hosting-noodle-token")
      ? localStorage.getItem("hosting-noodle-token")
      : null;

  constructor() {
    console.log("running api manager constrcutor", this.token);
  }

  static getInstance() {
    if (ApiManager.singleton == null) {
      ApiManager.singleton = new ApiManager();
    }
    return ApiManager.singleton;
  }

  setCreds = (token) => {
    this.token = token;
  };

  static POST = "post";
  static GET = "get";

  post = (endpoint, body) => {
    return new Promise((resolve, reject) => {
      let endpointUrl = this.generateEndpointUrl(endpoint);
      this._callServer(endpointUrl, body, ApiManager.POST)
        .then((json) => {
          resolve(json);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  //Use this function to make get calls to the server
  get = (endpoint, params) => {
    return new Promise((resolve, reject) => {
      let endpointUrl = this.generateEndpointUrl(endpoint) + this.convertToGetParams(params);
      this._callServer(endpointUrl, null, ApiManager.GET)
        .then((json) => {
          resolve(json);
        })

        .catch((error) => {
          reject(error);
        });
    });
  };

  postMulter = (endpoint, body, progressState) => {
    return new Promise((resolve, reject) => {
      let endpointUrl = this.generateEndpointUrl(endpoint);
      this._callServerMulter(endpointUrl, body, ApiManager.POST, progressState)
        .then((json) => {
          resolve(json);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  _callServerMulter = (endpointUrl, body, method, progressState) => {
    let headers = {};
    if (this.token) {
      headers = {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: "Bearer " + `${this.token}`,
      };
      //if token is not present but qomie_session_id is present
    } else {
      headers = {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      };
    }
    console.log("headers==>", ...body);

    return new Promise((resolve, reject) => {
      axios.post(endpointUrl, body, {
        headers: { ...headers },
        onUploadProgress: (progress) => {
          const { total, loaded } = progress;
          const totalSizeInMB = total / 1000000;
          const loadedSizeInMB = loaded / 1000000;
          const uploadPercentage = (loadedSizeInMB / totalSizeInMB) * 100;
          console.log("total size in MB ==> ", totalSizeInMB);
          console.log("uploaded size in MB ==> ", loadedSizeInMB);
          console.log("uploaded size in MB ==> ", uploadPercentage);
          progressState(Math.round(uploadPercentage));
        },
      });
    });
  };

  _callServer = (endpointUrl, body, method) => {
    let headers = {};
    if (this.token) {
      headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: "Bearer " + this.token,
      };
      //if token is not present but qomie_session_id is present
    } else {
      headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };
    }
    console.log("headers==>", headers);

    return new Promise((resolve, reject) => {
      fetch(endpointUrl, {
        method: method,
        headers: headers,
        mode: "cors",
        body: body !== null ? JSON.stringify(body) : null,
      })
        .then((response) => response.json())
        .then((json) => {
          console.log("json in fetch: ", endpointUrl, json);
          if (json.message === "1003" || json.message === "1004" || json.message === 5014 || json.message === 5067) {
            reject(json.message);
          } else if (json.message === "Unauthenticated." || json.message === "Unauthenticated") {
            reject({ message: "Unauthenticated" });
          } else {
            console.log("here json is", json);
            // json.responseData = JSON.parse(json.responseData);
            resolve(json);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  convertToGetParams = (params) => {
    let getParams = "";
    for (var key in params) {
      if (getParams !== "") {
        getParams += "&";
      }
      getParams += key + "=" + params[key];
    }
    return "?" + getParams;
  };

  generateEndpointUrl = (endpoint) => {
    return "https://api.hostingnoodle.com/auth" + endpoint;
    //return "http://192.168.100.77:5001/api" + endpoint;
    // return "http://localhost:8080" + "/auth" + endpoint;
  };
}
